import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import gaiaIcon from '../assets/gaia_icon.png';

interface MainLayoutProps {
  children: React.ReactNode;
  noPadding?: boolean;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children, noPadding = false }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        
        <main className="flex-1 overflow-y-auto bg-gray-50">
          <div className={noPadding ? "h-full" : "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 min-h-[calc(100vh-10rem)]"}>
            {children}
          </div>
          
          {/* Footer */}
          <footer className="bg-white border-t border-gray-200 mt-auto">
            <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
              <div className="flex justify-between items-center">
                <div className="flex items-center">
                  <img 
                    src={gaiaIcon} 
                    alt="GAIA Logo" 
                    className="h-8 w-auto"
                  />
                  <span className="ml-2 text-sm text-gray-700">
                    © 2026 GAIA. All rights reserved.
                  </span>
                </div>
                <div className="text-sm text-gray-600">
                  Powered by Jnanik AI
                </div>
              </div>
            </div>
          </footer>
        </main>
      </div>
    </div>
  );
};
